import { useGetAssignmentConfigQuery } from '@src/reducers/assignmentManager';
import { contactAssignedSelector } from '@src/selectors/contactAssignment';
import { selectAuthenticationInfo } from '@src/selectors/user';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import ContactAssignmentPopper from '../../AdminHome/Common/ContactAssignmentPopper';
import SelectorButton from './SelectorButton';

const ContactAssignSelector: React.FC<{ contactId: string }> = ({
  contactId,
}) => {
  const config = useGetAssignmentConfigQuery();
  const { admin } = useSelector(selectAuthenticationInfo);

  const editable =
    (admin || config.data?.assignmentSetterAllowed === 'ALL') && contactId;

  const assignedTo = useSelector(contactAssignedSelector(contactId));

  return (
    <ContactAssignmentPopper
      contactId={contactId}
      blockOpenPopper={!editable}
      placement="bottom-start"
      popperStyle={{
        marginTop: '16px',
      }}
    >
      <SelectorButton disabled={!contactId}>
        <FormattedMessage id="ContactAssigment.assignedTo" />:
        {assignedTo?.type === 'UNASIGNED' ? (
          <FormattedMessage id="ContactAssigment.assignedType.unassign" />
        ) : (
          assignedTo?.description
        )}
      </SelectorButton>
    </ContactAssignmentPopper>
  );
};

export default ContactAssignSelector;
